require("/Users/danielp/work/dan/uniter-projects/cube/node_modules/phpify/api/sync").installModules(function (path, checkExistence) {
    var exists = false;

    function handlePath(aPath) {
        if (!checkExistence) {
            return aPath;
        }

        if (aPath === path) {
            exists = true;
        }

        // Return something that should not match with the path variable,
        // so that the case itself is not executed and we eventually
        // reach the return after the end of the switch
        return null;
    }

    switch (path) {
    case handlePath("php/src/bootstrap.php"): return require("./../../../../php/src/bootstrap.php");
    case handlePath("php/src/Demo/Demo.php"): return require("./../../../../php/src/Demo/Demo.php");
    case handlePath("php/src/Demo/DemoFactory.php"): return require("./../../../../php/src/Demo/DemoFactory.php");
    case handlePath("vendor/autoload.php"): return require("./../../../../vendor/autoload.php");
    case handlePath("vendor/composer/ClassLoader.php"): return require("./../../../../vendor/composer/ClassLoader.php");
    case handlePath("vendor/composer/autoload_classmap.php"): return require("./../../../../vendor/composer/autoload_classmap.php");
    case handlePath("vendor/composer/autoload_files.php"): return require("./../../../../vendor/composer/autoload_files.php");
    case handlePath("vendor/composer/autoload_namespaces.php"): return require("./../../../../vendor/composer/autoload_namespaces.php");
    case handlePath("vendor/composer/autoload_psr4.php"): return require("./../../../../vendor/composer/autoload_psr4.php");
    case handlePath("vendor/composer/autoload_real.php"): return require("./../../../../vendor/composer/autoload_real.php");
    case handlePath("vendor/composer/autoload_static.php"): return require("./../../../../vendor/composer/autoload_static.php");
    case handlePath("vendor/symfony/polyfill-ctype/bootstrap.php"): return require("./../../../../vendor/symfony/polyfill-ctype/bootstrap.php");
    }

    return checkExistence ? exists : null;
})
.configure({"stdio":true}, [{}]);